import { render, staticRenderFns } from "./ResistanceLawViz.vue?vue&type=template&id=63933e65&scoped=true"
import script from "./ResistanceLawViz.vue?vue&type=script&lang=js"
export * from "./ResistanceLawViz.vue?vue&type=script&lang=js"
import style0 from "./ResistanceLawViz.vue?vue&type=style&index=0&id=63933e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63933e65",
  null
  
)

export default component.exports